import script from "./AssignSettings.vue?vue&type=script&lang=js"
export * from "./AssignSettings.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__